import { isVisibleAtScale } from '@agissc/ktag-map';
import { MapLayerSetting } from './Contracts';

const findCurrentLayer = (layerId: number, layers: MapLayerSetting[]) =>
  layers.find((layer) => layer.id === layerId);

export const isVisibleUpToRoot = (
  layerId: number,
  layers: MapLayerSetting[],
  resolution?: number,
): boolean => {
  let currentLayer = findCurrentLayer(layerId, layers);

  while (currentLayer) {
    if (currentLayer.isGroupLayer && !currentLayer.isEnabled) {
      return false;
    }

    if (!isVisibleAtScale(resolution, currentLayer.minScale, currentLayer.maxScale)) {
      return false;
    }

    if (currentLayer.isRoot) {
      return true;
    }

    currentLayer = findCurrentLayer(currentLayer?.parentLayerId, layers);
  }

  return false;
};
